import { render } from "./ProductInsurance.vue?vue&type=template&id=4b09b294&scoped=true"
import script from "./ProductInsurance.vue?vue&type=script&lang=js"
export * from "./ProductInsurance.vue?vue&type=script&lang=js"

import "./ProductInsurance.vue?vue&type=style&index=0&id=4b09b294&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b09b294"]])

export default __exports__